import { useState } from "react";
import { Stack, Group, Text, Badge, Timeline, Loader, Center, Paper, Collapse } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import moment from "moment-timezone";
import classes from './UpcomingExecutions.module.css';

interface UpcomingExecutionsProps {
	upcomingExecutions: Date[] | undefined;
	isLoading: boolean;
	lastExecuted?: Date;
}

export const UpcomingExecutions = ({ upcomingExecutions, isLoading, lastExecuted }: UpcomingExecutionsProps) => {
	const [isOpen, setIsOpen] = useState(false);
	if (isLoading) {
		return (
			<Center py="md">
				<Loader size="sm" />
			</Center>
		);
	}

	if (!upcomingExecutions || upcomingExecutions.length === 0) {
		return (
			<Center py="md">
				<Text c="dimmed">No upcoming executions</Text>
			</Center>
		);
	}

	return (
		<Stack gap="md" my="xl">
			<Group 
				justify="space-between"
				onClick={() => setIsOpen(!isOpen)}
				style={{ cursor: "pointer" }}
			>
				<Text fz="xs" fw="700" tt="uppercase" c="dimmed">Upcoming Executions ({upcomingExecutions.length})</Text>

				<Group gap="xs">
					{/* <Badge color="blue" variant="light">
						Next 10
					</Badge> */}
					{isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
				</Group>
			</Group>

			<Collapse in={isOpen}>
				<Timeline active={upcomingExecutions.length} bulletSize={24} lineWidth={2}>
					{upcomingExecutions.map((execution, index) => (
						<Timeline.Item
							key={index}
							bullet={index + 1}
							title={
								<Text fw={500} size="sm">
									{moment.utc(execution).local().format("dddd, MMMM DD, YYYY")}
								</Text>
							}
						>
							<Paper p="xs" radius="md" className={classes['executionPaper']}>
								<Text size="sm" c="dimmed">
									{moment.utc(execution).local().fromNow()}
								</Text>
							</Paper>
						</Timeline.Item>
					))}
				</Timeline>
			</Collapse>
		</Stack>
	);
};
